/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumera los campos que pueden editarse de una opinion.
 */
export type OpinionPatchFieldsEnum = 'calificacion' | 'personas';

export const OpinionPatchFieldsEnum = {
    Calificacion: 'calificacion' as OpinionPatchFieldsEnum,
    Personas: 'personas' as OpinionPatchFieldsEnum
};

